import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { t } from 'services/translation';
import MultiSelectDropdown from '../';

const { number, object, func, array } = PropTypes;

class GuestsMultiSelectDropdown extends Component {
  static propTypes = {
    max: number.isRequired,
    min: number.isRequired,
    unitTypes: object.isRequired,
    value: array.isRequired,
    onChange: func.isRequired,
    removeGuest: func.isRequired,
    guestList: array,
    unitPrices: object,
    for_guest: PropTypes.bool,
    disabled: PropTypes.bool,
    bookingId: number.isRequired,
    country: PropTypes.string,
    initialTicketQuantity: number.isRequired,
    capacityError: PropTypes.string,
    hasTicketCapacityEnabled: PropTypes.bool,
    slotTicketCapacities: PropTypes.array,
    timeSelected: PropTypes.bool,
    tourTicketCapacities: PropTypes.array,
    capacityErrorJobInProgress: PropTypes.string,
    isEditingCurrentSlot: PropTypes.bool,
    overbookedTicketCapacities: PropTypes.array,
    hasBookingUpdated: PropTypes.bool,
    isAAB: PropTypes.bool,
  };

  static defaultProps = {
    for_guest: false,
    disabled: false,
  };

  onChange = (id, delta, inputValue) => {
    const { unitTypes } = this.props;
    let newCount;
    const newValue = unitTypes.items.map((item) => ({
      id: item.id,
      count: delta
        ? this.countFor(item.id) + (id == item.id ? delta : 0)
        : id == item.id
          ? inputValue
          : this.countFor(item.id),
    }));
    this.props.onChange(newValue);
  };

  batchUnitsUpdate = () => {
    const { value, slotTicketCapacities } = this.props;
    const newValue = value.map((item) => {
      const slotCapacity = slotTicketCapacities?.find(
        (capacity) => capacity.unit_type_id === item.id
      );
      if (slotCapacity && slotCapacity.availability < 1) {
        return {
          id: item.id,
          count: 0,
        };
      }
      return item;
    });

    this.props.onChange(newValue);
  };

  _buildDropdownOptions() {
    const options = this.props.unitTypes.items.map((unitType) => ({
      ...unitType,
      count: this.countFor(unitType.id),
      price: this.priceFor(unitType.id),
      internalOnly: this.internalOnlyCheckFor(unitType.id),
    }));
    return options;
  }

  _totalCount() {
    return this.props.value.reduce((total, item) => total + item.count, 0);
  }

  countFor(id) {
    const item = this.props.value.find((unit) => unit.id === id);
    return item ? item.count : 0;
  }

  priceFor(id) {
    const { unitPrices } = this.props;

    if (!!unitPrices && !!unitPrices.items && unitPrices.items.length) {
      const unitPrice = unitPrices.items.find((item) => item.id === id);
      return unitPrice ? unitPrice.unit_price_formatted : '';
    }
    return '';
  }

  internalOnlyCheckFor(id) {
    const { unitPrices } = this.props;

    if (!!unitPrices && !!unitPrices.items && unitPrices.items.length) {
      const unitPrice = unitPrices.items.find((item) => item.id === id);
      return unitPrice ? unitPrice.internal_only : false;
    }
    return false;
  }

  updateGuestCountAndList = (item) => {
    const { addGuest } = this.props;
    this.onChange(item.unitTypeId, 1);
    addGuest(item);
  };

  updateGuestDetail = (item) => {
    const { updateGuest } = this.props;
    updateGuest(item);
  };

  render() {
    const {
      unitTypes,
      value,
      min,
      max,
      guestList,
      isGuestOfGuestEnabled,
      bookingId,
      unitPrices,
      removeGuest,
      renderToolTip,
      inPlaceEdit,
      for_guest,
      disabled,
      country,
      resetGuestList,
      onUpdateGuestDetail,
      initialTicketQuantity,
      capacityError,
      hasTicketCapacityEnabled,
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
      capacityErrorJobInProgress,
      isEditingCurrentSlot,
      overbookedTicketCapacities,
      hasBookingUpdated,
      isAAB,
    } = this.props;
    const { root } = unitTypes;
    const dropdownProps = {
      unitTypes,
      value,
      min,
      max,
      options: this._buildDropdownOptions(),
      totalCount: this._totalCount(),
      rootLabels: {
        singular: t(root.noun_singular),
        plural: t(root.noun_plural),
      },
      onChange: this.onChange,
      batchUnitsUpdate: this.batchUnitsUpdate,
      removeGuest,
      renderToolTip,
      inPlaceEdit,
      for_guest,
      disabled,
      guestList,
      isGuestOfGuestEnabled,
      bookingId,
      units: unitPrices,
      addGuest: this.updateGuestCountAndList,
      updateGuest: this.updateGuestDetail,
      onUpdateGuestDetail,
      country,
      resetGuestList,
      initialTicketQuantity,
      capacityError,
      hasTicketCapacityEnabled,
      slotTicketCapacities,
      timeSelected,
      tourTicketCapacities,
      capacityErrorJobInProgress,
      isEditingCurrentSlot,
      overbookedTicketCapacities,
      hasBookingUpdated,
      isAAB,
    };
    return <MultiSelectDropdown {...dropdownProps} />;
  }
}

export default GuestsMultiSelectDropdown;
